import { StoredProceduresTable } from '@pages/Transpiler/ImportedInfo/components/StoredProcedures';
import { Ellipsis, Stack, SwitchTabs, TabPane } from '@prophecy/ui-v3';
import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { SourceInfoType } from '../../../../data/apis/transpileTypes';
import { Error } from '../../Import/utils';
import { TabDetailTypes } from '../types';
import { ConfigsTable } from './ConfigsTable';
import { DatasetsTable } from './DatasetsTable';
import { JobsTable } from './JobsTable';
import { PipelinesTable } from './PipelinesTable';
import SourceTable from './SourceTable';
import { UdfsTable } from './UDfsTable';

export const EntityTabs = ({
  isBulk,
  id,
  type,
  projectName,
  overviewData,
  hasOverViewError,
  isOverviewLoading,
  isSql,
  projectId
}: {
  isBulk: boolean;
  id: string;
  isSql?: boolean;
  type: string;
  projectId?: string;
  overviewData: {
    entities: SourceInfoType[];
  };
  isOverviewLoading: boolean;
  hasOverViewError: boolean;
  projectName?: string;
}) => {
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(searchParams.get('tab') || TabDetailTypes.overview);
  if (hasOverViewError) {
    return <Error message='Some error occurred' />;
  }

  return (
    <SwitchTabs size='s' activeKey={activeTab} onChange={(tab) => setActiveTab(tab as TabDetailTypes)}>
      <TabPane tab={TabDetailTypes.overview} key={TabDetailTypes.overview}>
        <SourceTable
          loading={isOverviewLoading}
          type={type}
          isSql={isSql}
          projectId={projectId}
          projectName={projectName}
          transpilerId={id}
          sources={overviewData?.entities || []}
        />
      </TabPane>
      <TabPane tab={TabDetailTypes.pipelines} key={TabDetailTypes.pipelines}>
        <PipelinesTable id={id} isBulk={isBulk} isSql={isSql} projectId={projectId} />
      </TabPane>
      <TabPane tab={TabDetailTypes.jobs} key={TabDetailTypes.jobs}>
        <JobsTable id={id} isBulk={isBulk} />
      </TabPane>
      <TabPane tab={isSql ? TabDetailTypes.tables : TabDetailTypes.datasets} key={TabDetailTypes.datasets}>
        <DatasetsTable isSql={isSql} projectId={projectId} id={id} isBulk={isBulk} />
      </TabPane>
      {isSql ? (
        <TabPane
          tab={
            <Stack width='100px'>
              <Ellipsis tooltip={true}>{TabDetailTypes.storedProcedures}</Ellipsis>
            </Stack>
          }
          key={TabDetailTypes.storedProcedures}>
          <StoredProceduresTable isSql={isSql} projectId={projectId} id={id} isBulk={isBulk} />
        </TabPane>
      ) : (
        <TabPane tab={TabDetailTypes.configs} key={TabDetailTypes.configs}>
          <ConfigsTable id={id} isBulk={isBulk} />
        </TabPane>
      )}
      <TabPane tab={TabDetailTypes.udfs} key={TabDetailTypes.udfs}>
        <UdfsTable projectName={projectName} id={id} isBulk={isBulk} isSql={isSql} projectId={projectId} />
      </TabPane>
    </SwitchTabs>
  );
};
